import { Routes, HashRouter, Route, Navigate } from "react-router-dom";

import { AuthProvider } from "./context/auth";
import { ContractProvider } from "./context/contract";

import "./App.scss";
import PageContent from "./pages/PageContent/PageContent";
import Login from "./pages/Login/Login";
import ContractDetailsPage from "./pages/ContractDetails/ContractDetailsPage";
import CustomerSignature from "./pages/CustomerSignature/CustomerSignature";
import AgentSignature from "./pages/WitnessAndAgentSignatures/WitnessAndAgentSignatures";
import PageNotFound from "./pages/PageNotFound/PageNotFound";
import AuthGuard from "./guards/AuthGuard";
import ThankYou from "./pages/ThankYou/ThankYou";

function App() {
  return (
    <HashRouter>
      <AuthProvider>
        <ContractProvider>
          <Routes>
            <Route path="/digital-contract" element={<Login />} />

            <Route path="/digital-contract/contract" element={<PageContent />}>
              <Route
                path="details"
                element={
                  <AuthGuard>
                    <ContractDetailsPage />
                  </AuthGuard>
                }
              />
              <Route
                path="customer-signature"
                element={
                  <AuthGuard>
                    <CustomerSignature />
                  </AuthGuard>
                }
              />
              <Route
                path="witness-and-agent-signatures"
                element={
                  <AuthGuard>
                    <AgentSignature />
                  </AuthGuard>
                }
              />
              <Route
                index
                element={
                  <AuthGuard>
                    <Navigate to="/digital-contract/contract/details" />
                  </AuthGuard>
                }
              />
            </Route>
            <Route
              path="/digital-contract/not-found"
              element={<PageNotFound />}
            />
            <Route path="/digital-contract/thank-you" element={<ThankYou />} />
            <Route
              path="*"
              element={<Navigate to="/digital-contract/not-found" replace />}
            />
          </Routes>
        </ContractProvider>
      </AuthProvider>
    </HashRouter>
  );
}

export default App;
